import config from 'config';
import { TimeSignalAnalytic, TimeSignalDimensionType } from 'graphql/types';

const colorSet = [
  '#880e4f',
  '#4a148c',
  '#304ffe',
  '#006064',
  '#827717',
  '#3e2723',
  '#212121',
  '#00c853',
  '#00e5ff',
  '#ab47bc',
  '#cddc39',
  '#4caf50',
  '#ad1457',
  '#616161',
  '#8d6e63',
  '#ec407a',
  '#80cbc4',
  '#546e7a'
];

const manualNoteSourceColor = '#ef6c00';
const getChartColor = (index: number): string => {
  const colorSetLength = colorSet.length;
  if (index > colorSetLength - 1) {
    return colorSet[(index % colorSetLength) - 1];
  } else return colorSet[index];
};

export const sampleData: TimeSignalAnalytic = {
  dimensions: [
    {
      dimensionType: TimeSignalDimensionType.MetricsBySource,
      id: 'bf5b0e0471404014b699b8057e5af2df',
      name: 'Zoom',
      metadata: [
        {
          key: 'image',
          value:
            'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzI5LjA4IDEzMjkuMDgiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiB0ZXh0LXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiBpbWFnZS1yZW5kZXJpbmc9Im9wdGltaXplUXVhbGl0eSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxkZWZzPjxzdHlsZT4uZmlsMXtmaWxsOiNmZmY7ZmlsbC1ydWxlOm5vbnplcm99PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyX3gwMDIwXzEiPjxnIGlkPSJfMjExNjQ2NzE2OTc0NCI+PHBhdGggZD0iTTY2NC41NCAwYzM2Ny4wMiAwIDY2NC41NCAyOTcuNTIgNjY0LjU0IDY2NC41NHMtMjk3LjUyIDY2NC41NC02NjQuNTQgNjY0LjU0UzAgMTAzMS41NiAwIDY2NC41NCAyOTcuNTIgMCA2NjQuNTQgMHoiIGZpbGw9IiNlNWU1ZTQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGNsYXNzPSJmaWwxIiBkPSJNNjY0LjU0IDEyLjk0YzM1OS44NyAwIDY1MS42IDI5MS43MyA2NTEuNiA2NTEuNnMtMjkxLjczIDY1MS42LTY1MS42IDY1MS42LTY1MS42LTI5MS43My02NTEuNi02NTEuNiAyOTEuNzQtNjUxLjYgNjUxLjYtNjUxLjZ6Ii8+PHBhdGggZD0iTTY2NC41NCA2NS4yMWMzMzEgMCA1OTkuMzMgMjY4LjMzIDU5OS4zMyA1OTkuMzMgMCAzMzEtMjY4LjMzIDU5OS4zMy01OTkuMzMgNTk5LjMzLTMzMSAwLTU5OS4zMy0yNjguMzMtNTk5LjMzLTU5OS4zMyAwLTMzMSAyNjguMzMtNTk5LjMzIDU5OS4zMy01OTkuMzN6IiBmaWxsPSIjNGE4Y2ZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBjbGFzcz0iZmlsMSIgZD0iTTI3My41MyA0NzYuNzd2MjgxLjY1Yy4yNSA2My42OSA1Mi4yNyAxMTQuOTUgMTE1LjcxIDExNC42OWg0MTAuNTVjMTEuNjcgMCAyMS4wNi05LjM5IDIxLjA2LTIwLjgxVjU3MC42NWMtLjI1LTYzLjY5LTUyLjI3LTExNC45NS0xMTUuNy0xMTQuNjlIMjk0LjZjLTExLjY3IDAtMjEuMDYgOS4zOS0yMS4wNiAyMC44MXptNTczLjQ1IDEwOS44N2wxNjkuNS0xMjMuODJjMTQuNzItMTIuMTggMjYuMTMtOS4xNCAyNi4xMyAxMi45NHYzNzcuNTZjMCAyNS4xMi0xMy45NiAyMi4wOC0yNi4xMyAxMi45NGwtMTY5LjUtMTIzLjU3VjU4Ni42NHoiLz48L2c+PC9nPjwvc3ZnPg=='
        }
      ]
    },
    {
      dimensionType: TimeSignalDimensionType.MetricsBySource,
      id: '40d4f621f61d4d8d8226533cfe724838',
      name: 'direct',
      metadata: [
        {
          key: 'image',
          value: null
        }
      ]
    }
  ],
  metrics: [
    {
      totalDuration: 12883,
      totalCount: 10
    },
    {
      totalDuration: 1282,
      totalCount: 10
    }
  ]
};

export function transformAnalyticsData(
  data: TimeSignalAnalytic | undefined
): {
  x: string;
  y: number;
  name: string;
  value: number;
  color: string;
  imgSrc: string | undefined;
}[][] {
  if (!data) {
    return [];
  }
  const dataSet = data.dimensions.map((_data, index) => {
    let color: string;
    const isManualSource = _data.id === config.clientId;
    if (isManualSource) {
      color = manualNoteSourceColor;
    } else {
      color = getChartColor(index);
    }
    return {
      x: 'SOURCE',
      name: isManualSource ? 'Manual Entries' : _data.name,
      imgSrc:
        _data.metadata?.find((x) => x?.key === 'image')?.value ?? undefined,
      y: data.metrics[index].totalDuration,
      value: data.metrics[index].totalDuration,
      color: color
    };
  });

  const totals = dataSet.reduce((memo, curr) => {
    return memo + curr.y;
  }, 0);
  dataSet.sort((a, b) => b.value - a.value);
  return dataSet.map((d) => {
    return [
      {
        x: d.x,
        y: (d.y / totals) * 100,
        name: d.name,
        value: d.value,
        color: d.color,
        imgSrc: d.imgSrc
      }
    ];
  });
}
